import React, { useState, useEffect } from 'react';
import { 
  Drawer, 
  AppBar, 
  Toolbar, 
  Typography, 
  Unstable_Grid2 as Grid2, 
  Button,
  Box 
} from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [username, setUsername] = useState(""); // State to store username

  const handleNavigate = (path) => {
    navigate(path); // Programmatically navigate to the desired path
  };
  const navigate = useNavigate(); // Initialize useNavigate

  // Fetch username from sessionStorage when the component mounts
  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername); // Update state with username from sessionStorage
    }
  }, []); // Empty dependency array to run this effect only on mount

  return (
    <Box sx={{ display: 'flex' }}>
      {/* AppBar (top-right username) */}
      <AppBar position="fixed" sx={{ zIndex: 1300 }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Dashboard
          </Typography>
          <Typography variant="body1">{username}</Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        sx={{
          width: 240,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 240,
            paddingTop: 8,
            boxSizing: 'border-box',
            color: 'white',
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Box sx={{ paddingTop: 1 }}>
          <Grid2 container direction="column" spacing={0.5}>
            <Grid2 item height={100}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleNavigate("/arxiv")}
                sx={{
                  height: 100,
                  backgroundColor: '#F96C3DFF',
                  fontSize: 20,
                  fontWeight: 'bold',
                  textTransform: 'none',
                  ":hover": {
                    backgroundColor: '#ff9800',
                  },
                }}
              >
                Arxiv Review
              </Button>
            </Grid2>
            <Grid2 item height={100}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleNavigate("/pubmed")}
                sx={{
                  height: 100,
                  backgroundColor: '#08C1BBFF',
                  fontSize: 20,
                  fontWeight: 'bold',
                  textTransform: 'none',
                  ":hover": {
                    backgroundColor: '#008CFFFF',
                  },
                }}
              >
                PubMed Review
              </Button>
            </Grid2>
            <Grid2 item height={100}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleNavigate("/pubmed_plus")}
                sx={{
                  height: 100,
                  backgroundColor: '#A8C108FF',
                  fontSize: 20,
                  fontWeight: 'bold',
                  textTransform: 'none',
                  ":hover": {
                    backgroundColor: '#C6BC00FF',
                  },
                }}
              >
                PubMed Review Plus
              </Button>
            </Grid2>
            <Grid2 item height={100}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleNavigate("/utils")}
                sx={{
                  height: 100,
                  backgroundColor: '#BB08C1FF',
                  fontSize: 20,
                  fontWeight: 'bold',
                  textTransform: 'none',
                  ":hover": {
                    backgroundColor: '#BB00FFFF',
                  },
                }}
              >
                Utils
              </Button>
            </Grid2>
          </Grid2>
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', paddingTop: 8, paddingLeft: 0 }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Dashboard;
